<template>
  <!-- IS HARD CODED VERSION OF StatusCircle.component.vue -->
  <!-- size: 60, stop_color: '#F44336', count: 5, stroke_width: 0.7, inner_radius_factor: 0.75, space: 3 -->
  <div class="status-circle-standard status-circle-standard-width-height">
    <svg class="status-circle-standard-outline" width="100%" height="100%" viewBox="0 0 60 60" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
      <path
        :fill="color || '#000'"
        d="M16.201,53.335L16.201,53.335C24.457,58.196 35.038,58.516 43.8,53.334C44.077,53.17 44.169,52.812 44.005,52.535L40.629,46.827C40.465,46.55 40.107,46.458 39.83,46.622C33.588,50.313 26.05,50.085 20.169,46.621L20.169,46.621C19.892,46.458 19.535,46.55 19.371,46.827L15.995,52.535C15.831,52.812 15.923,53.17 16.2,53.334L16.201,53.335ZM20.083,47.915L17.3,52.62C24.965,56.903 34.597,57.174 42.7,52.621L39.918,47.916C33.58,51.426 26.08,51.22 20.083,47.915ZM3.543,24.087L3.543,24.087C1.471,33.441 4.437,43.603 12.072,50.335C12.314,50.548 12.683,50.525 12.896,50.283L17.281,45.309C17.494,45.067 17.471,44.698 17.229,44.485C11.79,39.69 9.678,32.45 11.154,25.786L11.154,25.786C11.224,25.473 11.026,25.161 10.712,25.091L4.24,23.644C3.926,23.574 3.614,23.772 3.544,24.086L3.543,24.087ZM48.846,25.787C50.428,32.864 47.881,39.963 42.77,44.486L42.77,44.486C42.529,44.699 42.506,45.068 42.719,45.309L47.104,50.283C47.317,50.525 47.686,50.548 47.928,50.335L47.928,50.334L47.928,50.334C55.103,43.985 58.677,34.02 56.456,24.086C56.386,23.772 56.074,23.574 55.76,23.644L49.288,25.091C48.974,25.161 48.776,25.473 48.846,25.787ZM4.563,24.912C2.858,33.525 5.577,42.769 12.411,49.069L16.026,44.969C10.729,40.026 8.607,32.829 9.897,26.104L4.563,24.912ZM55.439,24.912L50.104,26.104C51.484,33.216 48.97,40.286 43.973,44.968L47.589,49.068C54.031,43.102 57.264,34.025 55.439,24.912ZM27.448,3.011L27.448,3.011C17.911,3.931 9.163,9.892 5.12,19.234C4.993,19.529 5.129,19.873 5.424,20.001L11.51,22.634C11.806,22.762 12.149,22.626 12.277,22.331C15.157,15.676 21.39,11.43 28.184,10.775L28.184,10.775C28.504,10.744 28.739,10.459 28.709,10.139L28.084,3.537C28.054,3.216 27.769,2.981 27.449,3.011L27.448,3.011ZM31.817,10.775C39.037,11.457 45.001,16.073 47.723,22.332L47.723,22.332C47.851,22.626 48.195,22.762 48.49,22.634L54.576,20.001C54.871,19.873 55.007,19.529 54.88,19.234L54.879,19.233L54.879,19.233C51.058,10.447 42.685,3.969 32.551,3.011C32.231,2.981 31.946,3.216 31.916,3.537L31.291,10.139C31.261,10.46 31.497,10.744 31.817,10.775ZM33.022,4.234L32.507,9.676C39.698,10.561 45.644,15.137 48.553,21.336L53.57,19.165C49.887,11.194 42.253,5.314 33.022,4.234ZM26.979,4.235C18.26,5.275 10.308,10.718 6.429,19.164L11.446,21.335C14.51,14.77 20.699,10.528 27.493,9.677L26.979,4.235Z"
      />
    </svg>
    <div
      class="status-circle-standard-segment status-circle-standard-width-height"
      v-for="n in 5"
      :key="`circle-segment-${n}`"
      :style="`transform: rotate(${(n - 1) * 72 + 5.4}deg);`"
    >
      <svg :width="60" :height="60" viewBox="0 0 36 36" >
        <!-- FILL -->
        <path
          class="status-circle-standard-fill"
          :d="`M18 4.0739375
            a 13.9260625 13.9260625 0 0 1 0 27.852125
            a 13.9260625 13.9260625 0 0 1 0 -27.852125`"
          fill="none"
          :stroke="!is_stop
            ? color || '#000'
            : '#F44336'"
          stroke-width="3.978875"
          stroke-dasharray="14.875, 100"
          :stroke-dashoffset="`${(n - 1) >= filled_count ? 14.875 : 0}`"
        />
      </svg>
    </div>
    <div class="status-circle-standard-content">
      <slot
        name="content"
      />
    </div>
  </div>
</template>

<script>
  export default {
    components: {

    },

    props: [
      'filled_count', // is number, index of status (first is 1)
      'is_stop', // is boolean, turns circle segments to stop_color
      'color', // is string, contains hexadecimal value of text, outlines etc.
    ],

    data: () => ({

    }),
  }
</script>

<style>
.status-circle-standard {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.status-circle-standard-content {
  position: absolute;
  overflow: hidden;
}
.status-circle-standard-segment {
  position: absolute;
  top: 0;
  overflow: hidden;
}
.status-circle-standard-outline {
  z-index: 1; 
}
.status-circle-standard-fill {
  transition:
    stroke-dashoffset 0.5s ease-in-out,
    stroke .33s ease-in-out;
}
.status-circle-standard-width-height {
  width: 60px;
  height: 60px;
}
</style>
